import React from "react";

interface NewChatModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const NewChatModal: React.FC<NewChatModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="dark:bg-gray-800 bg-gray-200 rounded-lg shadow-xl max-w-sm w-full mx-4 overflow-hidden border dark:border-gray-700 border-gray-300">
        <div className="border-b dark:border-gray-700 border-gray-300 px-6 py-4">
          <h3 className="text-lg font-medium dark:text-white text-gray-600">
            Start New Chat
          </h3>
        </div>
        <div className="p-6 border-b dark:border-gray-700 border-gray-300">
          <p className="dark:text-gray-300 text-gray-500 mb-6">
            Are you sure you want to start a new chat? This will clear the current
            conversation.
          </p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-base font-medium dark:text-gray-300 text-gray-500 dark:hover:bg-gray-800 hover:bg-gray-100 rounded-md transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-base font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-md transition-colors duration-200"
            >
              Start New Chat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewChatModal;
